import React, { useCallback } from 'react';
import { router, usePage } from '@inertiajs/react';
import LanguageSwitcher from '../../LanguageSwitcher';
import FlashMessage from '../app/FlashMessage';
import Footer from './Footer';
import { useTrans } from '../../../hooks/useTrans';

export default function PublicLayout({ children }) {
    const translate = useTrans();
    const { auth, deliveryAppointment } = usePage().props;

    const handleLanguageSwitch = useCallback((languageKey) => {
        router.post('/language', { _method: 'PUT', language_id: languageKey });
    }, []);

    const showAppointmentLink = auth && deliveryAppointment?.show && deliveryAppointment?.url;

    return (
        <div className="sticky-end">
            <div className="sticky-end-header">
                <header className="portal__header">
                    <div className="wrapper wrapper--large">
                        <div className="combined combined--no-gutter combined--middle">
                            <div className="combined-body flex-item flex--align-center flex--space-between">
                                <a href="/" className="schotpoort-logo" title="Schotpoort Connect">Schotpoort Connect</a>

                                {showAppointmentLink && (
                                    <a
                                        href={deliveryAppointment.url}
                                        target="_blank"
                                        rel="noreferrer"
                                        title={translate('Ga naar de afspraakmodule van deze order')}
                                        className="flex-item flex-item--row flex--align-center button button-green"
                                        style={{ fontSize: '1.3rem', marginRight: '15px' }}
                                    >
                                        <span>{translate('Afspraakmodule')}</span>
                                    </a>
                                )}
                            </div>
                            <div className="combined-aside">
                                <div className="portal__header__actions">
                                    <LanguageSwitcher onSwitch={handleLanguageSwitch} />
                                </div>
                            </div>
                        </div>
                    </div>
                </header>
            </div>

            <div className="sticky-end-body">
                <section className="portal__main portal__main--alt" role="main">
                    <div className="wrapper wrapper--large wrapper--no-gutter-mobile">
                        <FlashMessage />
                        {children}
                    </div>
                </section>
            </div>

            <div className="sticky-end-footer">
                <Footer />
            </div>
        </div>
    );
}
